const verticalNav = {
  init: () => {
    let divs = document.querySelectorAll(".js-vertical-nav-trigger");
    let links = document.querySelectorAll(".vertial-nav_item");
    window.addEventListener("scroll", () => {
      divs.forEach((div) => {
        let id = div.getAttribute("id");
        let elData = verticalNav.elementInViewport(div);
        if (elData.topHalf == true && elData.bottomHalf == false) {
          document
            .querySelector(`.vertical-nav_item[data-id="${id}"]`)
            .classList.add("is-active");
        } else {
          document
            .querySelector(`.vertical-nav_item[data-id="${id}"]`)
            .classList.remove("is-active");
        }
      });
    });
  },
  elementInViewport: (el) => {
    let vh = window.innerHeight || document.documentElement.clientHeight; // alcuni browser
    let elRect = el.getBoundingClientRect();
    let data = {
      topHalf: false,
      bottomHalf: false,
    };
    if (elRect.top < vh / 2) {
      data.topHalf = true;
    }
    if (elRect.height + elRect.y < vh / 2) {
      data.bottomHalf = true;
    }
    return data;
  },
};

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".vertical-nav")) {
    verticalNav.init();
  }
});
